import {Container, VStack} from '@styled-system/jsx';
import {h1} from '@styled-system/recipes';
import {lazy, Suspense} from 'react';
import {db} from 'shared/utils/db.server';
import {PointData} from '~/components/WinnersMap.client';
import RecentWinners from '~/components/RecentWinners';
import {superjson, useSuperLoaderData} from '~shared/utils/data';

const LazyWinnersMap = lazy(() => import('~/components/WinnersMap.client'));

export const loader = async () => {
  const winners = await db.winner.findMany({
    select: {
      id: true,
      name: true,
      location: true,
      longitude: true,
      latitude: true,
      imageUrl: true,
      giveaway: {
        select: {
          id: true,
          title: true,
          imageUrl: true,
          endDate: true,
        }
      }
    },
    orderBy: {
      giveaway: {
        endDate: 'desc'
      }
    }
  });

  return superjson({
    winners: winners.map(w => ({
      id: w.id,
      coordinates: [w.longitude.toNumber(), w.latitude.toNumber()],
      name: w.name,
      location: w.location,
      imageUrl: w.imageUrl ?? w.giveaway.imageUrl ?? undefined,
      giveawayId: w.giveaway.id,
      giveawayTitle: w.giveaway.title,
      date: w.giveaway.endDate,
    } satisfies PointData))
  })
}

const WinnersPage = () => {
  const {winners} = useSuperLoaderData<typeof loader>();

  return <Container>
    <VStack width="full" gap={8} py={8}>
      <h1 className={h1()}>
        Meet Our Winners
      </h1>
      <Suspense fallback={null}>
        <LazyWinnersMap points={winners}/>
      </Suspense>
      <RecentWinners winners={winners}/>
    </VStack>
  </Container>;
}

export default WinnersPage;
